//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { setToken } from '@/utils/token';
import { login } from '@/api/login';
export default {
  data: function data() {
    return {
      param: {
        username: 'admin',
        password: '123456'
      },
      rules: {
        username: [{
          required: true,
          // 非空
          message: '用户名不能为空',
          // 提示文字
          trigger: 'blur' // 触发时机

        }, {
          min: 2,
          max: 7,
          message: '长度在 2 到 7 个字符',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          // 非空
          message: '密码不能为空',
          // 提示文字
          trigger: 'blur' // 触发时机

        }, {
          min: 6,
          max: 16,
          message: '长度在 6 到 16 个字符',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    submitForm: function submitForm() {
      var _this = this;

      this.$refs.login.validate(function (valid) {
        if (valid) {
          login(_this.param).then(function (res) {
            console.log(res);

            if (res.code == 0) {
              _this.$message.success('登录成功');

              localStorage.setItem('ms_username', _this.param.username);
              setToken(res.token);

              _this.$router.push('/');
            } else if (res.code == 1) {
              _this.$message.error('用户名或密码错误');
            }
          });
        } else {
          _this.$message.error('请输入账号和密码');

          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};